module.exports = __webpack_public_path__ + "media/images/recruit/mv/img-mark-02-694d8aa4d389318c160c3036c465130a.svg";